import React, { useEffect } from "react";
import { tokens } from "../../../../theme";
import { useGetOrderView } from "../../../../General/Hooks";
//redux
import { useDispatch, useSelector } from "react-redux";
import { closeViewoeModalR } from "../../../../General/Store/GeneralSlice";
//mui
import { Box, Modal, useTheme } from "@mui/material";

//style
import "../../style/style.css";
import GeneralError from "../../../../General/Components/Error/GeneralError";
import LoadingScreen from "../../../Organization/Chart/Components/LoadingScreen";
const LazyviewOrder = React.lazy(() =>
  import("../../../../General/Components/OrderView/OrederView")
);
function ViewOrder({ type, setDyModal, afterClose, curentStep,useOrderOnline=false,afterSubmitForm=()=>{} }) {
  const theme = useTheme();
  const colora = tokens(theme.palette.mode);
  const style = {
    position: "absolute",
    width: "99%",
    bgcolor: colora.grey[900],
    border: "0",
    left: "0",
    right: "0",
    margin: "auto",
    padding: "2rem 1rem",
    p: 4,
    borderRadius: "0.5rem",
    boxShadow:
      " 0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)",
  };
  const dispatch = useDispatch();
  const EditeModalShow = useSelector((state) => state.general.viewModal);

  /* -------------------------------------------------------------------------- */
  /*                               FunctionHandle                               */
  /* -------------------------------------------------------------------------- */

  const handleClose = () => {
    dispatch(closeViewoeModalR());
    setDyModal && setDyModal(null);
    afterClose(null);
    afterSubmitForm();
    console.log('runnnnnnnnnn')
    
  };

  //give data from redux and pass custom hoock for request and give data view order
  const getOrderViewoId = useSelector(
    (state) => state.general.orderViewIdSelected
  );

  const { data, isError, mutate, isLoading } = useGetOrderView();

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  useEffect(() => {
    if (getOrderViewoId && EditeModalShow) {
      mutate(
        type === "id"
          ? { orderId: getOrderViewoId, userId: userInfo?.userId }
          : { orderId: getOrderViewoId?.id, userId: userInfo?.userId }
      );
    }
  }, [getOrderViewoId, EditeModalShow]);

  useEffect(() => {
    if (isError) {
      dispatch(closeViewoeModalR());
    }
  }, [isError]);
  if (isError) {
    return <GeneralError text={"متاسفانه خطایی رخ داده است"} />;
  } else if (data) {
    return (
      EditeModalShow && (
        <div>
          <Modal
            open={EditeModalShow}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ padding: "1rem", overflowY: "auto" }}
          >
            <Box sx={style}>
              <div className="modal-container">
                <LazyviewOrder
                  curentStep={curentStep}
                  afterClose={afterClose}
                  viewData={data?.data.data}
                  setDyModal={setDyModal}
                  useOrderOnline={useOrderOnline}
                  afterSubmitForm={afterSubmitForm}
                />
              </div>
            </Box>
          </Modal>
        </div>
      )
    );
  } else if (isLoading) {
    return (
      <Modal
        open={true}
        onClose={() => {}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ padding: "1rem", overflowY: "auto" }}
      >
        <LoadingScreen />
      </Modal>
    );
  }
}

export default ViewOrder;
